import { Component } from '@angular/core';
import { AccountType } from '../../interfaces/api/AccountType';
import { ApiService, UserInfo } from '../../services/api.service'
import { debounceTime, distinctUntilChanged, Subject } from 'rxjs';
import { AnalyticsService } from 'app/services/analytics.service';
import { environment } from '../../../environments/environment'
import { LanguageParserService } from '../../services/language-parser.service'
import { SalesforceService } from '../../services/salesforce.service'
import { TranslateService } from '@ngx-translate/core'

@Component({
    selector: 'app-mysamples',
    templateUrl: './mysamples.component.html',
    styleUrls: ['./mysamples.component.scss'],
})
export class MysamplesComponent {
    userInfo: UserInfo
    searchTerm: string | null = null;
    page: number = 0;
    samples: any[] = [];
    hasNextPage: boolean = false;
    status: string | null = null;
    searching: boolean = false;

    constructor(
        private api: ApiService,
        private analytics: AnalyticsService,
        private languageParser: LanguageParserService,
        private canvas: SalesforceService,
        private translate: TranslateService,
    ) {}

    private translations(){
        this.translate.get([
            'order_samples.all',
            'order_samples.requested',
            'order_samples.received',
        ])
    }

    ngOnInit() {
        this.api.userInfo.subscribe((userInfo) => (this.userInfo = userInfo))
        this.fetchSamples()
    }

    protected readonly AccountType = AccountType

    tabs = [
        { value: 'all', label: 'order_samples.all', gtmLabel: 'order-samples_filter_all' },
        { value: 'requested', label: 'order_samples.requested', gtmLabel: 'order-samples_filter_requested' },
        { value: 'received', label: 'order_samples.received', gtmLabel: 'order-samples_filter_received' },
    ]
    activeTab = this.tabs[0].value

    fetchSamples() {

        if (this.page == 0) {
            this.samples = []
        }

        let filterBody: Record<string, string | number | null> = {
            status: this.status,
            page: this.page,
            search: this.searchTerm,
        }
        // Filtrar los pares clave-valor que tengan valor nulo
        const filteredParams = Object.entries(filterBody)
            .filter(([key, value]) => value !== null)
            .reduce((obj, [key, value]) => {
                if (value !== null) {
                    obj[key] = value as string // Type assertion to string
                }
                return obj
            }, {} as Record<string, string>)

        this.api.getSamplesList(filteredParams).subscribe((response: any) => {
            if (this.page != 0) {
                this.samples = this.samples ? this.samples.concat(response.samples) : response.samples
            } else {
                this.samples = response.samples
            }
            this.hasNextPage = response.hasNextPage;
            this.searching = false;
            console.log(this.samples)
        })
        this.searching = false;
    }

    onSearch(term: string) {
        this.searching = true;
        this.searchTerm = term;
        this.page = 0;
        this.samples = [];

        this.analytics.track({
            event: 'search',
            search_term: term,
            type: 'order-samples'
        });

        this.fetchSamples();
    }

    onTabChanged(tabValue: string) {
        this.activeTab = tabValue;

        this.status = tabValue;
        if (tabValue !== 'requested' && tabValue !== 'received') {
            this.status = null;
        }

        this.page = 0;
        this.samples = [];
        this.fetchSamples();
    }

    goToRequestSamples() {
        const lang = this.languageParser.getShortLanguage(this.userInfo?.locale)
        const samplesUrl = `${environment.samplesEndpoint}?language=${lang}`
        if(this.canvas.isCanvas() && window.top){
            window.top.postMessage({
                type: "navigateTo",
                communityPage: "",
                externalUrl: samplesUrl,
                params: "",
                newTab: false
            }, environment.salesforceUrl);
        } else {
            window.location.href = samplesUrl;
        }
    }

    nextPage() {
        this.page++;
        this.fetchSamples();
    }

}
